import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/app/app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  support: defineAsyncComponent(() => import("/app/app/layouts/support.vue").then(m => m.default || m))
}